export function isVariation(variationKey, targetVariation) {
  return variationKey === targetVariation;
}
